import { DialogActions, FormControl, Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import PropTypes from "prop-types";
import { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { globalHistory } from "../../history";
import { mapActionsToProps } from "./../../redux/agent";

class CreateAgent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      fullname: "",
      extensionId: "",
      agentGroupId: "",
    };
  }

  componentDidMount() {
    this.history = globalHistory();
    this.props.getListGroupAgent();
  }

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleSubmit = () => {
    const { name, fullname, extensionId, agentGroupId } = this.state;
    this.props.addNewAgent(name, fullname, extensionId, agentGroupId);
  };

  render() {
    const { classes, listAgentGroups } = this.props;
    const { name, fullname, extensionId, agentGroupId } = this.state;
    const listAgentGroupsResult =
      typeof listAgentGroups === "object"
        ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
        : listAgentGroups;
    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <span className={classes.breadCrumb}>
            <Button
              size="small"
              disableRipple={true}
              onClick={() => this.history.push("/agent")}>
              <ArrowBackIos color="primary" />
              Danh sách điện thoại viên
            </Button>
          </span>
          <div style={{ flexGrow: 1 }}></div>
        </Toolbar>

        <div style={{ overflowX: "auto" }}>
          <ValidatorForm
            ref="form"
            onSubmit={this.handleSubmit}
            onError={(errors) => console.log(errors)}
            className={classes.form}>
            <FormControl className={classes.form}>
              <Grid container className={classes.grid}>
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Mã điện thoại viên"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChange("name")}
                  value={name}
                  name="name"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Tên điện thoại viên"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChange("fullname")}
                  value={fullname}
                  name="fullname"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Máy lẻ"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChange("extensionId")}
                  value={extensionId}
                  name="extensionId"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
                <SelectValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Nhóm"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChange("agentGroupId")}
                  value={agentGroupId}
                  select
                  name="agentGroupId"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}>
                  {listAgentGroupsResult
                    ? listAgentGroupsResult.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </SelectValidator>
              </Grid>
              <DialogActions>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  type="submit">
                  Thêm điện thoại viên
                </Button>
              </DialogActions>
            </FormControl>
          </ValidatorForm>
        </div>
      </Paper>
    );
  }
}

CreateAgent.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  toolbar: {
    paddingLeft: theme.spacing.unit,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  grid: {
    width: "100%",
    padding: theme.spacing.unit * 3,
  },
});
const mapStateToProps = (state) => ({
  listAgentGroups: state.agent.groupAgent,
});

CreateAgent = connect(mapStateToProps, mapActionsToProps)(CreateAgent);

export default withStyles(styles)(CreateAgent);
